import { useMemo } from "react";
import { getTranslatedFieldByLocale } from "../../utils/translatedFields";
import { useDaphne } from "./useDaphne";
import { useI18n } from "./useI18n";
import { VaccineWithDiseases, getDiseasesNames } from "./useVaccinesWithDiseases";

export function useVaccineWithDiseases(vaccineId: string | undefined): VaccineWithDiseases | undefined {
  const daphne = useDaphne();
  const { locale } = useI18n();

  return useMemo(() => {
    if (!daphne || !vaccineId) {
      return undefined;
    }

    const vaccine = daphne.repositories.vaccines.find(vaccineId);

    if (!vaccine) {
      return undefined;
    }

    const diseases = daphne.queries.diseasesByVaccine(vaccine);
    const vaccineName = getTranslatedFieldByLocale(locale, vaccine.name);
    const diseasesName = getDiseasesNames(diseases, locale);

    return {
      vaccine,
      diseases,
      vaccineName,
      diseasesName,
      vaccineNameWithDiseases: `${vaccineName}${diseasesName ? ` (${diseasesName})` : ""}`,
    };
  }, [daphne, vaccineId, locale]);
}
